import React from "react";
import InstagramIcon from "mdi-react/InstagramIcon"
import TwitterIcon from "mdi-react/TwitterIcon"
import FacebookIcon from "mdi-react/FacebookIcon";
import Colors from "../Colors";

class SocialMenu extends React.Component {

    constructor(props) {
        super(props)
        this.state = {

        }
    }


    render() {
        return (
            <div className="cat-container" style={{display: "flex", flexDirection:"column", marginLeft:10, marginTop:10}}>
                <div style={{display:"flex", justifyContent:"center"}}>
                    <a style={{ display: "flex", textDecoration: "none", margin:15 }} className="text-hover" href={"https://www.instagram.com/richless.app"} target="_blank" rel="noopener noreferrer">
                        <InstagramIcon style={{ alignSelf: "center", color: Colors.middleText  }} name="instagram" size={25} />
                        {/* <span style={{ marginLeft: 5, color: "#555" }}>richless.app</span> */}
                    </a>
                    <a style={{ display: "flex", textDecoration: "none", margin:15 }} className="text-hover" href={"https://www.facebook.com/richless.app"} target="_blank" rel="noopener noreferrer">
                        <FacebookIcon style={{ alignSelf: "center", color: Colors.middleText }} name="facebook" size={25} />
                       {/*  <span style={{ marginLeft: 5, color: "#555" }}>richless.app</span> */}
                    </a>
                    <a style={{ display: "flex", textDecoration: "none", margin:15 }} className="text-hover" href={"https://www.twitter.com/richlessapp"} target="_blank" rel="noopener noreferrer">
                        <TwitterIcon style={{ alignSelf: "center", color: Colors.middleText }} name="twitter" size={25} />
                        {/* <span style={{ marginLeft: 5, color: "#555" }}>richless.app</span> */}
                    </a>
                </div>
                <a href='https://play.google.com/store/apps/details?id=com.godapp.richless.app' style={{display:"flex", justifyContent:"center"}}>
                    <img alt='Get it on Google Play' style={{width:"65%"}}
                     src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                </a>
            </div>
        );
    };

    
}
export default SocialMenu